/* eslint-disable no-undef */
import '../../containers/offer-listing/index.scss';
import './index.scss';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import Carousel from '../../components/carousel';
import GeneralCard from '../../components/card-general';
import HorizontalScroll from '../../components/horizontal-scroll';
import Button from '../../components/button';
import CartSticky from '../../components/cart-sticky';
import DealsOfTheDay from '../../components/deals-of-the-day';
import LoaderBackDrop from '../../components/loader-backdrop';
import Loader from '../../components/loader-spin';
import OngoingOrder from '../../components/ongoing-order';
import Footer from '../../containers/footer';
import MobileFooter from '../../containers/mob-footer';
import OffersModalContent from '../../containers/offers-modal-content';
import ProductDetailPage from '../custom-product-detail';
import Login from '../login';
import OffersToast from '../../components/offers-toast';
import {
  getHomeApiList,
  getToken
} from '../../burger-king-lib/redux/home/actions';
import {
  getCoupons,
  getUserAvailablePoints
} from '../../burger-king-lib/redux/offers/actions';
import {
  feedbackApiV2,
  getFeedbackStatusList,
  getTicketStatusList,
  isViewedUpdateApi,
  updateFeedbackApi
} from '../../burger-king-lib/redux/orders/actions';
import { getAllAddons } from '../../burger-king-lib/redux/productListing/actions';
import LocationRestriction from '../../components/location-restriction-popover';
import { ROUTES as _routes } from '../../constants/app-constants';
import FeedbackPage from '../new-feedback-page';
import FeedbackPagee from '../new-feedback-page/newpop';
import RatingPage from '../new-rating-page';
import InfinteScreen from '../new-ui';
import { LocalSessionKey } from '../../burger-king-lib/constants/app-constants';
import RepeatCustomization from '../../components/repeat-customization';
import Modal from '../../containers/modal';

import BKWallBannerImageMobile from '../../../assets/images/home-bk-wall-mob.jpg';
import BKWallBannerImage from '../../../assets/images/home-bk-wall.jpg';
import { ADD_NEW_FEEDBACK_API } from '../../burger-king-lib/constants/api-constants';

import OfferOnboarding from '../../burger-king-code/offer-onboarding';
import { getOutletChange1 } from '../../burger-king-lib/redux/cart/actions';
import {
  alterRedisCart,
  postRedisCart
} from '../../burger-king-lib/redux/redisCart/actions';
import {
  LocalStorage,
  SessionStorage
} from '../../burger-king-lib/utils/storage.web';
import Cancelpop from '../../components/cancel-popover';
import CartCustomize from '../../components/cart-customize';
import { Analytics } from '../../helpers/analytics';
import FeedbackLatest from '../../pages/feedback';
import {
  addToCartPayload,
  addToCartUpdatedPayload,
  alterCartItemPayload
} from '../../payload-handling/cart';
import { homeApiListPayload } from '../../payload-handling/home';
import {
  getCouponsPayload,
  getUserAvailablePointsPayload
} from '../../payload-handling/offers';
import { getAllAddonsPayload } from '../../payload-handling/product-listing';
import {
  generateSelectedAddonsName,
  getCartItemCountAndPrice1
} from '../../utils/services';
import SwipeCarousel from '../../components/swipeCarousel';
import { trackEvent } from '../../../analytics_wrapper';
import {
  category_homepage,
  explore_menu,
  homescreen_banner,
  kingdeals_banner,
  kingdeals_homepage,
  nearbystore_homepage,
  view_order,
  web_launch
} from '../../../analyics_constants';

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      viewedOrder: [],
      showModal: false,
      pdpCollapse: false,
      apiListData: [],
      cartData: [],
      pdpItem: {},
      showRepeatCustomization: false,
      showBackDropLoader: false,
      showLoader: true,
      activeKey: 'home',
      showOngoingOrder: false,
      stopCarouselSlideShow: false,
      showOfferDealModal: false,
      showLoginModal: false,
      offersModalContentValue: '',
      userAvailablePoints: 0,
      couponCode: '',
      isLoggedIn: this.isLoggedIn(),
      ongoingOrderData: {},
      toastMessage: '',
      onRestrict: false,
      orderStatus: {},
      title: '',
      couponErrorPopup: '',
      couponError: false,
      outletStatus: {},
      showFeedback: false,
      showRating: false,
      fromTickets: false,
      isFromTable: false,
      isFunctionCalled: false,
      continueClicked: false,
      selectIndex: null,
      addonDetails: [],
      showPopUp: false,
      showCluboffer: false
    };

    this.offerClickedFrom = '';
  }

  componentDidMount() {
    const { location, theme, homeData } = this.props;
    trackEvent(web_launch, {
      order_mode: SessionStorage.get(LocalSessionKey.ORDER_TYPE),
      mobile_no: LocalStorage.get(LocalSessionKey.USER_DATA),
      city: homeData?.homeApiList?.content?.outlet_info?.city
        ? homeData?.homeApiList?.content?.outlet_info?.city
        : '',
      state: homeData?.homeApiList?.content?.outlet_info?.state
        ? homeData?.homeApiList?.content?.outlet_info?.state
        : '',
      platform: SessionStorage.get(LocalSessionKey.PLATFORM)
    });

    trackEvent(location, {
      order_mode: SessionStorage.get(LocalSessionKey.ORDER_TYPE),
      mobile_no: LocalStorage.get(LocalSessionKey.USER_DATA),
      city: homeData?.homeApiList?.content?.outlet_info?.city
        ? homeData?.homeApiList?.content?.outlet_info?.city
        : '',
      location: homeData?.homeApiList?.content?.outlet_info?.address
        ? homeData?.homeApiList?.content?.outlet_info?.address
        : '',
      lat: homeData?.homeApiList?.content?.outlet_info?.lat
        ? homeData?.homeApiList?.content?.outlet_info?.lat
        : '',
      long: homeData?.homeApiList?.content?.outlet_info?.long
        ? homeData?.homeApiList?.content?.outlet_info?.long
        : ''
    });

    if (location.search.includes('table_id')) {
      this.openPopUp(true);
    } else if (location.search.includes('store_id')) {
      const arr = location.search.split('&');
      const outlet = arr[0].split('=')[1];
      window.sessionStorage.setItem('OUTLET_ID', outlet);
      this.getHomeApiList(outlet);
    } else if (
      location?.search?.includes('bank_name') &&
      location?.search?.includes('bank_id')
    ) {
      window.location.href = `https://burgerkingindia.page.link/gNpB`;
    } else {
      if (LocalStorage.get(LocalSessionKey.USER_ID)) {
        if (LocalStorage.get(LocalSessionKey.TOKEN)) {
          this.getHomeApiList();
          // this.getAllAddonsData();
          const { isLoggedIn } = this.state;
          if (isLoggedIn) {
            this.getFeedbackStatusData();
          }
        }
      }
      const s =
        this.props &&
        this.props.history &&
        this.props.history.location &&
        this.props.history.location.state;
      if (!!s && 'isFromDeeplink' in s && s?.isFromDeeplink) {
        this.exploreFullMenuclickHandler(s?.category_id, s);
      }
    }
    if (this.props?.location?.pathname === '/feedback') {
      this.setState({
        show: false,
        showPopUp: true
      });
    }
    if (this.props?.location?.pathname === '/offer-onboarding') {
      this.setState({
        show: false,
        showCluboffer: true
      });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      homeData,
      cartData,
      offersData,
      orderHistoryData,
      loginData,
      feedbackStatus,
      ticketStatus,
      theme
    } = this.props;

    if (homeData && homeData.homeApiList !== prevProps.homeData.homeApiList) {
      if (homeData.homeApiList.content) {
        if (homeData.homeApiList.content.home) {
          this.setHomeApiList(homeData.homeApiList.content.home);
          this.setCartItem(homeData.homeApiList.content.cart_data.content);
        }
        if (homeData.homeApiList.content.outlet_info)
          this.setOutletInfoData(homeData.homeApiList.content.outlet_info);
        this.setToastRestaurantName(homeData.homeApiList.content.outlet_info);
        SessionStorage.set(
          LocalSessionKey.ESTIMATED_TIME,
          homeData?.homeApiList?.content?.outlet_info?.estimated_time
        );
        SessionStorage.set(
          LocalSessionKey.IS_ESTIMATED_TIME,
          homeData?.homeApiList?.content?.outlet_info?.is_express_delivery
        );
        if (
          homeData.homeApiList.content.is_outlet_active === false ||
          homeData.homeApiList.content.is_outlet_active === true
        ) {
          this.setOutletData(
            homeData.homeApiList.content.outlet_status,
            homeData.homeApiList.content.outlet_status_header,
            homeData.homeApiList.content.is_outlet_active
          );
        }
      }
      if (homeData.homeApiList.message) {
        this.hideLoader();
        this.hideBackDropLoader();
      }
    }
    if (
      homeData &&
      homeData.menuList &&
      homeData.menuList !== prevProps.homeData.menuList
    ) {
      if (homeData.meta || homeData.menuList.content || homeData.menuList) {
        const data =
          feedbackStatus &&
          feedbackStatus.content &&
          feedbackStatus.content.feedback;
        const myData = ticketStatus?.content;
        const ongoingStatus = feedbackStatus?.content?.ongoing;

        this.fun(data);
        this.getIsticketsClosed(myData);

        this.setState({
          orderStatus: ongoingStatus
        });
      }
    }

    if (
      cartData &&
      cartData !== prevProps.cartData &&
      cartData.addRemoveCartItem !== prevProps.cartData.addRemoveCartItem
    ) {
      if (cartData.addRemoveCartItem.error)
        alert(cartData.addRemoveCartItem.message);
      else if (cartData.addRemoveCartItem.error === 0) {
        this.setCartItem(cartData.addRemoveCartItem.content);
        this.closeOfferDealsClickHandler();
        this.updateCategoryItemData();
      }
      if (cartData.addRemoveCartItem.message === 'Your cart is empty.') {
        this.setCartItem([]);
      }
    }
    if (
      cartData &&
      cartData !== prevProps.cartData &&
      cartData.outletChange !== prevProps.cartData.outletChange
    ) {
      if (cartData.outletChange.content && cartData.outletChange.error === 0) {
        if (cartData.outletChange.content.message)
          alert(cartData.outletChange.content.message);
      }
    }

    if (
      cartData &&
      cartData !== prevProps.cartData &&
      cartData.postCart !== prevProps.cartData.postCart
    ) {
      if (cartData.postCart.error) {
        alert(cartData.postCart.message);
        this.closeOfferDealsClickHandler();
      } else if (cartData.postCart.error === 0) {
        this.setCartItem(cartData.postCart.content, cartData.postCart.alert);
        this.closeOfferDealsClickHandler();
        this.updateCategoryItemData();
      }
      if (cartData.postCart.message && !this.categoryPayload) {
        this.hideBackDropLoader();
      }
    }
    if (
      offersData &&
      offersData !== prevProps.offersData &&
      offersData.getCoupons !== prevProps.offersData.getCoupons
    ) {
      if (offersData.getCoupons.error === 0) {
        this.hideBackDropLoader();
        if (offersData.getCoupons.content)
          this.setCouponCode(offersData.getCoupons.content);
      }
      if (offersData.getCoupons.error === 1) {
        this.setErrorPopup(offersData.getCoupons.message);
        this.hideBackDropLoader();
      }
    }

    if (
      (offersData && offersData !== prevProps.offersData) ||
      offersData.getUserAvailablePoints !==
        prevProps.offersData.getUserAvailablePoints
    ) {
      if (
        offersData.getUserAvailablePoints.error === 0 &&
        offersData.getUserAvailablePoints.content
      ) {
        this.setuserAvailablePoints(offersData.getUserAvailablePoints.content);
      }
    }

    if (
      orderHistoryData &&
      orderHistoryData.orderHistoryList &&
      orderHistoryData.orderHistoryList !==
        prevProps.orderHistoryData.orderHistoryList
    ) {
      if (
        orderHistoryData.orderHistoryList.content &&
        orderHistoryData.meta === 'home' &&
        orderHistoryData.orderHistoryList.error === 0
      )
        this.setOngoingOrderItem(orderHistoryData.orderHistoryList.content);
    }

    if (loginData && loginData.verifyOtp !== prevProps.loginData.verifyOtp) {
      if (loginData.verifyOtp.error === 0) {
        this.loginSuccessHandler();
      }
    }

    if (homeData && homeData.data !== prevProps.homeData.data) {
      if (
        homeData &&
        homeData.data &&
        homeData.data.content &&
        homeData.data.content.token
      ) {
        const { isLoggedIn } = this.state;
        this.getHomeApiList();
      }
    }
    if (
      homeData &&
      homeData.menuList &&
      homeData.menuList !== prevProps.homeData.menuList &&
      homeData.menuList.length !== prevProps.homeData.menuList.length &&
      homeData.menuList.length > 0
    ) {
      this.setCategoryMenuList(homeData.menuList);
      this.setNewData(homeData.menuList);
    }
  }

  openPopUp = val => {
    const { location } = this.props;
    const arr = location.search.split('&');
    let latLng = {
      lat: Number(arr?.[3]?.split('=')[1]),
      lng: Number(arr?.[4]?.split('=')[1])
    };
    latLng = JSON.stringify(latLng);
    window.sessionStorage.setItem('OUTLET_ID', arr[0].split('=')[1]);
    window.localStorage.setItem('LAT_LNG', latLng);
    window.sessionStorage.setItem('TABLE_ID', arr[1].split('=')[1]);
    this.getHomeApiList();
    // }
  };

  openPopUp1 = val => {
    const isPopUpshowed = window.sessionStorage.getItem('isPopUpshowed');
    if (!isPopUpshowed) {
      window.sessionStorage.setItem('isPopUpshowed', 'true');
      // Show the popup logic here
      this.setState({
        isFromTable: val
      });
    }
  };

  getTokenData = () => {
    const { getTokenData } = this.props;
    getTokenData();
  };

  getOfferData1 = offerData => {
    this.setState({
      offerData1: offerData,
      offerApply: true
    });
  };

  getHomeApiList = outletId => {
    const searchParams = new URLSearchParams(
      this.props.history?.location?.search
    );
    const { getHomeApiListData, theme } = this.props;
    let payload;
    if (outletId) {
      payload = { outlet_id: outletId };
    } else if (searchParams.has('store_id') || searchParams.has('deep_link_sub1')) {

      const latLng = LocalStorage.get(LocalSessionKey.LAT_LNG);
      
      payload = {
        lat: Number(latLng && latLng.lat) || 0,
        long: Number(latLng && (latLng.long || latLng.lng)) || 0,
        outlet_id: searchParams.get('store_id') ||  searchParams.get('deep_link_sub1'),

      };
    } else {
      payload = homeApiListPayload(theme);
    }

    getHomeApiListData(payload, 'FROM HOME');
  };

  getUserAvailablePointsData = () => {
    const { getUserAvailablePointsData } = this.props;
    const phone_no = LocalStorage.get(LocalSessionKey.USER_DATA);
    if (phone_no) {
      const payload = getUserAvailablePointsPayload(phone_no);
      getUserAvailablePointsData(payload);
    }
  };

  setOutletInfoData = item => {
    const { location, theme } = this.props;
    if (
      item.lat &&
      item.long &&
      location?.search?.includes('store_id') &&
      !location?.search?.includes('lat')
    ) {
      let latlong = {
        lat: item.lat,
        long: item.long
      };
      latlong = JSON.stringify(latlong);
      window &&
        window.localStorage &&
        window.localStorage.setItem('LAT_LNG', latlong);
    }
    if (
      location?.search?.includes('store_id') &&
      !location?.search?.includes('lat') &&
      theme === 'takeaway'
    ) {
      const { getOutletChangeData } = this.props;
      getOutletChangeData(
        {
          ...item,
          location: item.outlet_name
        },
        { page: 'home - if-setOutletInfoData' }
      );
    } else if (
      location?.search?.includes('store_id') &&
      location?.search?.includes('type') &&
      !location?.search?.includes('lat') &&
      !location?.search?.includes('long')
    ) {
      const { getOutletChangeData } = this.props;
      getOutletChangeData(
        {
          ...item,
          location: item.outlet_name.split(',')[0]
        },
        { page: 'home - elseif-setOutletInfoData' }
      );
    }
    if (
      (location?.search?.includes('table_id') || location?.search?.includes('deep_link_value')) &&
      item.table_data.is_table_ordering_enabled &&
      !(window.sessionStorage.getItem('isPopUpshowed') === 'true')
    ) {
      this.setState({
        isFromTable: true
      });
    }
  };

  componentWillUnmount() {
    window.localStorage.removeItem('isPopUpshowed');
  }

  setOutletData = (value, head, active) => {
    if (active) {
      if (SessionStorage.get('Store_Status')) {
        SessionStorage.remove('Store_Status');
      }
    } else {
      const status = {
        title: head,
        status: value
      };
      SessionStorage.set('Store_Status', status);
      this.setState({ outletStatus: status });
    }
  };

  onokayClickHandler = () => {
    this.setState({ onRestrict: false });
  };

  onokayCouponClickHandler = () => {
    this.setState({ couponError: false });
  };

  updateIsViewed = id => {
    const { getIsViewedUpdateApi } = this.props;
    const viewed = [
      {
        feedback_id: id
      }
    ];
    const payload = {
      viewed
    };
    const meta = {
      key: 'home'
    };
    getIsViewedUpdateApi(payload, meta);
  };

  getFeedbackApiV2 = (data, rating) => {
    const { postFeedbackApiV2 } = this.props;
    const payload = {
      order_id: data.id,
      type: data.cart_added_for,
      overall_rating: rating
    };
    const meta = {
      key: 'home'
    };
    postFeedbackApiV2(payload, meta);
  };

  callUpdateFeedbackApi = (data, rating) => {
    const { updateFeedback } = this.props;
    const payload = {
      order_id: data.id,
      updated_rating: rating
    };
    const meta = {
      key: 'home'
    };
    updateFeedback(payload, meta);
  };

  constCall = (showState, order) => {
    if (showState === undefined && order === undefined) {
      this.setState({
        showRating: true
      });
    } else {
      const feedbackId = order?.feedback_id;
      this.updateIsViewed(feedbackId, showState);
      if (showState === 'close') {
        window &&
          window.YellowMessengerPlugin &&
          window.YellowMessengerPlugin.openBot();
        this.setState({
          showFeedback: false,
          fromTickets: false
        });
      } else {
        this.setState({ showFeedback: false, showRating: true });
      }
    }
  };

  getFeedbackStatusData = () => {
    const { getFeedbackStatus, getTicketStatus } = this.props;
    const payload = {};
    const meta = {
      key: 'home'
    };
    getFeedbackStatus(payload, meta);
  };

  getAllAddonsData = () => {
    const { getAllAddonsData } = this.props;
    const payload = getAllAddonsPayload();
    getAllAddonsData(payload);
  };

  setCartItem = (data, alert) => {
    this.otherPopUpHide(false);
    if (
      alert &&
      Object.values(alert).length > 0 &&
      !window.localStorage.getItem('popupShown')
    ) {
      this.getOfferData1(alert);
    }
    const cartData = getCartItemCountAndPrice1(data);
    this.setState({ cartData, selectIndex: null });
  };

  getAddOnConcat = data => {
    const { product_addons } = data;
    let addonConcat = '';
    if (product_addons && product_addons.length)
      product_addons.forEach(addonData => {
        if (addonConcat) addonConcat += ' + ';
        addonConcat +=
          addonData.quantity > 1
            ? `${addonData.addon_name} * ${addonData.quantity}`
            : addonData.addon_name;
        return addonData;
      });
    return addonConcat;
  };

  setHomeApiList = data => {
    const outlet_id =
      data[0] &&
      data[0].backend_data &&
      data[0].backend_data.postdata &&
      data[0].backend_data.postdata.outlet_id;
    SessionStorage.set(LocalSessionKey.OUTLET_ID, outlet_id);
    this.setState({ apiListData: data });
  };

  setToastRestaurantName = outlet_info => {
    const newData = window.sessionStorage.getItem('theme');
    if (outlet_info && outlet_info.outlet_name && newData !== 'delivery') {
      const { getOutletChangeData } = this.props;
      getOutletChangeData(
        {
          ...outlet_info,
          location: outlet_info.outlet_name
        },
        { page: 'home - setToastRestaurantName' }
      );
    }
  };

  updateCategoryItemData = () => {
    const { apiListData1 } = this.state;
    if (apiListData1 && apiListData1.length) {
      const data = apiListData1?.filter(
        data =>
          data?.content?.flex_details?.type === 'promoproducts' ||
          data?.content?.flex_details?.type === 'favourites'
      );
      if (data && data.length) {
        this.setState({ showBackDropLoader: true });
        this.getHomeApiList();
      }
    }
  };

  isLoggedIn = () => {
    const user_data = LocalStorage.get(LocalSessionKey.USER_DATA);
    if (user_data) return true;
    return false;
  };

  setNewData = data => {
    this.setState({ apiListData1: data });
  };

  setCategoryMenuList = (content, type) => {
    const { apiListData } = this.state;
    const filterdata = apiListData.filter((data, index) => {
      if (data.type === type) {
        data.index = index;
        return data;
      }
      return null;
    });

    if (filterdata && filterdata[0]) {
      const [firEl] = filterdata;
      const { index } = firEl;
      apiListData[index].data = content.result;
    }

    if (this.categoryPayload && this.categoryPayload.backend_data) {
      this.categoryPayload = null;
      this.setState({ showBackDropLoader: false });
    }
    this.setState({ apiListData });
  };

  fun = oldData => {
    const viewed =
      oldData && oldData.length > 0
        ? oldData.filter(item => !item.is_already_viewed)
        : [];
    this.setState({ viewedOrder: viewed });
    if (viewed?.length > 0) {
      this.setState({ showFeedback: true });
    }
  };

  getIsticketsClosed = ticketStatus => {
    let viewed = [];
    viewed = ticketStatus?.filter(
      item =>
        item?.ticket_status === 'Close' &&
        item?.order_detai[0]?.is_feedback_updated === false
    );
    if (viewed?.length > 0) {
      this.setState({
        showFeedback: false,
        fromTickets: true,
        updatedOrder: viewed
      });
      if (this.state.viewedOrder.length === 0) {
        this.setState({
          fromTickets: true
        });
      }
    }
    const payload = {
      viewed
    };
  };

  hideBackDropLoader = () => {
    this.setState({ showBackDropLoader: false });
  };

  hideLoader = () => {
    this.setState({ showLoader: false });
  };

  getCouponsData = data => {
    console.log(data, ' data ');
    const { getCouponsData } = this.props;
    const payload = getCouponsPayload(data);
    getCouponsData(payload);
  };

  cardImgOnClickHandler = (data, categoryPayload) => {
    const { is_has_addons, is_combo } = data;
    if (is_has_addons || is_combo) {
      if (data.variants_quantity === 1) {
        if (data.addons_quantity !== 0) {
          const payloadForNextApi = {
            entity_id: data.variant_category[0].variants[0].entity_id,
            name: data.name,
            product_id: data.id
          };
          this.setState({
            continueClicked: true,
            pdpItem: data,
            pdpCollapse: true,
            // title,
            isNextCloseAll: true,
            payloadForNextApi
          });
        } else {
          const payloadForNextApi = {
            entity_id: data.entity_id,
            name: '',
            isItCombosFlow: false
          };
          this.setState({
            pdpItem: data,
            showModal: false,
            continueClicked: true,
            isNextCloseAll: true,
            payloadForNextApi
          });
        }
      } else {
        this.setState({
          showModal: true,
          pdpItem: data
        });
      }
    }
    this.categoryPayload = categoryPayload;
  };

  loginModalOpenHandler = () => {
    this.setState({ showLoginModal: true });
  };

  loginSuccessHandler = () => {
    this.setState({ showBackDropLoader: true, isLoggedIn: true });
    this.getTokenData();
  };

  isRedeemed = data => {
    const { is_redemed } = data;
    if (data && is_redemed) {
      return true;
    }
    return false;
  };

  selectedFun = (index, details) => {
    this.setState({
      selectIndex: index,
      payloadForNextApi: {
        entity_id: details?.entity_id,
        product_id: details?.product_id,
        name: details?.name,
        variant_name: details?.name,
        imageUrls: details?.image_urls
      },
      selectedVariant: details
    });
  };

  showOfferDealsModalHandler = itemData => {
    const { isLoggedIn, outletStatus } = this.state;
    const { theme } = this.props;
    let isLogged = false;
    if (LocalStorage.get(LocalSessionKey.USER_DATA)) {
      isLogged = true;
    }
    if (isLoggedIn || isLogged) {
      const outletid = SessionStorage.get(LocalSessionKey.OUTLET_ID);
      if (outletid === 32236 || (outletStatus && outletStatus.status)) {
        this.setState({ onRestrict: true });
      } else {
        if (itemData?.is_recommended === true) {
          if (itemData?.offer_type === 'category') {
            const { category_id } = itemData;
            const { apiListData1 } = this.state;
            const filterCategoryMenuData = apiListData1.filter(
              item => item.content?.flex_details?.type === 'menu'
            );
            let categoryName = '';
            filterCategoryMenuData &&
              filterCategoryMenuData[0] &&
              filterCategoryMenuData[0].content.result.categories.forEach(
                items => {
                  if (items.id === category_id) {
                    categoryName = items.name;
                  }
                }
              );
            this.exploreFullMenuclickHandler(category_id);
          }
          if (itemData?.product?.[0]?.variants_quantity === 1) {
            if (itemData?.product?.[0]?.addons_quantity !== 0) {
              const payloadForNextApi = {
                entity_id:
                  itemData?.product?.[0]?.variant_category[0].variants[0]
                    .entity_id || itemData?.product?.[0]?.variant?.v_entity_id,
                name:
                  itemData?.product?.[0]?.name ||
                  itemData?.product?.[0]?.variant?.name,
                product_id:
                  itemData.product?.[0]?.id ||
                  itemData?.product?.[0]?.product_id,
                type: 'deals_of_the_day'
              };
              this.setState({
                continueClicked: true,
                pdpItem: itemData?.product?.[0],
                pdpCollapse: true,
                title: '"Recommendations"',
                isNextCloseAll: true,
                payloadForNextApi
              });
            } else {
              const payloadForNextApi = {
                entity_id:
                  itemData?.product?.[0]?.variant?.v_entity_id ||
                  itemData?.product?.[0]?.entity_id,
                name: '',
                isItCombosFlow: false
              };
              this.setState({
                pdpItem: itemData?.product?.[0],
                showModal: false,
                continueClicked: true,
                isNextCloseAll: true,
                payloadForNextApi
              });
            }
          } else {
            this.setState({
              showModal: true,
              pdpItem: itemData?.product?.[0],
              pdpCollapse: true,
              title: '"Recommendations"'
            });
          }
        } else {
          const { crowns_to_burn } = itemData;
          if (!crowns_to_burn) {
            this.getCouponsData(itemData);
            this.setState({ showBackDropLoader: true });
          } else {
            this.setState({
              showOfferDealModal: false,
              offersModalContentValue: itemData
            });
          }
          this.offerClickedFrom = 'deals_of_the_day';
        }
      }
      const addressInfo = SessionStorage.get(LocalSessionKey.RESTAURANT_DETAIL);
      trackEvent(kingdeals_banner, {
        order_mode: SessionStorage.get(LocalSessionKey.ORDER_TYPE),
        city: addressInfo?.city,
        banner_id: itemData?.id,
        banner_name: itemData?.title,
        crown_points: window.localStorage.getItem('crowns')
          ? window.localStorage.getItem('crowns')
          : 0
      });
    } else {
      this.loginModalOpenHandler();
    }
  };

  burnValueOnClickHanlder = data => {
    this.getCouponsData(data);
    this.setState({ showBackDropLoader: true });
  };

  setuserAvailablePoints = data => {
    if (data && data.available_points) {
      const { available_points } = data;
      this.setState({ userAvailablePoints: available_points });
      SessionStorage.set('TotalCrowns', { earned: available_points });
    }
  };

  setCouponCode = data => {
    const outletid = SessionStorage.get(LocalSessionKey.OUTLET_ID);
    const outletStatus = SessionStorage.get('Store_Status') || {};
    let toast = '';
    if (outletid !== 32236 || (outletStatus && outletStatus.status)) {
      toast = 'Offer has been added to Saved King Deals';
    }
    if (data && data.title) {
      const { coupon_code } = data;
      this.setState({
        couponCode: data?.coupon_code,
        offersModalContentValue: data,
        showOfferDealModal: true,
        toastMessage: toast
      });
      this.updateOfferWithReedemKey(data);
    }
  };

  termsAndConditionClickHandler = () => {
    const { history } = this.props;
    history.push(_routes.TERMS_AND_CONDITIONS);
  };

  closeOfferDealsClickHandler = () => {
    this.setState({
      showOfferDealModal: false,
      stopCarouselSlideShow: false,
      isFunctionCalled: false
    });
    this.getHomeApiList();
  };

  onLoginSuccessHandler = () => {
    const { isLoggedIn } = this.state;
    if (isLoggedIn) {
      this.setState({
        showLoginModal: false,
        showLoader: true,
        stopCarouselSlideShow: false
      });
      this.getHomeApiList();
    }
    this.setState({ showLoginModal: false, stopCarouselSlideShow: false });
  };

  loggedInToggleHandler = data => {
    if (data) {
      const { isLoggedIn } = this.state;
      this.setState({ isLoggedIn: !isLoggedIn });
    }
  };

  updateOfferWithReedemKey = data => {
    const { apiListData } = this.state;
    const homeApiListFilteredData = apiListData.filter(
      item => item.type === this.offerClickedFrom
    );
    if (
      homeApiListFilteredData &&
      homeApiListFilteredData[0] &&
      homeApiListFilteredData[0].data &&
      homeApiListFilteredData[0].data.length
    ) {
      const offerData = homeApiListFilteredData[0].data.filter(
        item => item.offer_id === data.offer_id
      );
      if (offerData && offerData[0]) offerData[0].is_redemed = true;
    }
  };

  closeClickHandler = (flag, index) => {
    // selectIndex: null
    const { showModal, apiListData } = this.state;

    if (
      typeof flag === 'undefined' &&
      typeof index === 'undefined' &&
      showModal
    ) {
      console.log({ flag, index }, ' selectIndex ', showModal);
      this.setState({
        selectIndex: null, // Set selectedIndex to null
        showModal: !showModal,
        pdpCollapse: false,
        stopCarouselSlideShow: false
      });
      return;
    } else {
      this.setState({
        showModal: showModal,
        pdpCollapse: false,
        stopCarouselSlideShow: false
      });
    }
    if (flag) {
      this.otherPopUpShow(this.state.selectIndex, showModal);
    }
  };

  otherPopUpShow = (index, showModal = null) => {
    this.setState({
      continueClicked: true,
      selectIndex: index
    });
  };

  otherPopUpHide = (flag, extra) => {
    if (extra !== 'pl' && this.state.isNextCloseAll) {
      this.setState({
        continueClicked: false,
        showModal: false,
        showBackDropLoader: false,
        itIsFrom: 'normal'
      });
      return;
    }
    if (this.state.isFrom && this.state.isFrom === 'customise') {
      this.toggleLoader();
      this.setState({
        continueClicked: false,
        showModal: false,
        itIsFrom: 'normal',
        showBackDropLoader: false
      });
      return;
    } else {
      this.setState({
        continueClicked: false
      });
    }
    if (flag) {
      this.closeClickHandler(false);
    }
  };

  exploreFullMenuclickHandler = (id, extra, buttonTitle) => {
    const { history, theme } = this.props;
    const { apiListData1 } = this.state;
    const addressInfo = SessionStorage.get(LocalSessionKey.RESTAURANT_DETAIL);
    const newId =
      typeof id === 'string'
        ? id
        : apiListData1?.[1]?.content?.result?.categories?.[0]?.id;
    const filterCategoryMenuData =
      apiListData1 &&
      apiListData1?.length > 0 &&
      apiListData1?.filter(data => data.content?.flex_details?.type === 'menu');
    let categoryName = '';
    if (apiListData1 && apiListData1.length > 0) {
      apiListData1.forEach(data => {
        const matchingCategory = data?.content?.result?.categories?.find(
          category => category?.id === newId
        );
        if (matchingCategory) {
          categoryName = matchingCategory?.name || '';
        }
      });
    }
    const path = {
      pathname:
        window.innerWidth < 768
          ? _routes.M_PRODUCT_LISTING
          : _routes.PRODUCT_LISTING,
      state: {
        categoryId: newId,
        data: apiListData1,
        menuData: filterCategoryMenuData?.[0]?.content?.result,
        extra
      }
    };
    history.push(path);
    if (buttonTitle === 'Explore full menu') {
      trackEvent(explore_menu, {
        order_type: theme,
        city: addressInfo?.city ? addressInfo?.city : '',
        category_name: categoryName,
        crown_points: window.localStorage.getItem('crowns')
          ? window.localStorage.getItem('crowns')
          : 0
      });
    } else {
      trackEvent(category_homepage, {
        order_mode: SessionStorage.get(LocalSessionKey.ORDER_TYPE),
        city: addressInfo?.city ? addressInfo?.city : '',
        category_name: categoryName,
        crown_points: window.localStorage.getItem('crowns')
          ? window.localStorage.getItem('crowns')
          : 0
      });
    }
  };

  addItemClickHandler = (isAdd, item, categoryPayload, title) => {
    if (item && item.id) {
      const { is_has_addons, is_combo, is_addon_added, cart_quantity } = item;
      this.categoryPayload = categoryPayload;
      if (is_combo || is_has_addons) {
        if (is_addon_added && !isAdd) {
          this.setState({ showCartCustomization: true });
        } else if (!is_addon_added && !isAdd) {
          if (item.cart_item_id) {
            const { removeCartItemData } = this.props;
            const payload = alterCartItemPayload(item?.cart_item_id, isAdd);
            removeCartItemData(payload);
            this.setState({ lastAddedItem: payload, showBackDropLoader: true });
          } else {
            this.addToCartPayloadHandler(isAdd, item);
          }
        } else if (isAdd && cart_quantity >= 1) {
          item.addonConcat = generateSelectedAddonsName(item);
          this.setState({
            showRepeatCustomization: true,
            pdpItem: item
          });
        } else if (isAdd) {
          if (item.variants_quantity === 1) {
            if (item.addons_quantity !== 0) {
              const payloadForNextApi = {
                entity_id:
                  item.variant_category[0].variants[0].entity_id ||
                  item?.variant?.v_entity_id,
                name: item?.name || item?.variant?.name,
                product_id: item.id || item?.product_id
              };
              this.setState({
                continueClicked: true,
                pdpItem: item,
                pdpCollapse: true,
                title,
                isNextCloseAll: true,
                payloadForNextApi
              });
            } else {
              const payloadForNextApi = {
                entity_id: item?.variant?.v_entity_id || item?.entity_id,
                name: '',
                isItCombosFlow: false
              };

              this.setState({
                pdpItem: item,
                showModal: false,
                continueClicked: true,
                isNextCloseAll: true,
                payloadForNextApi
              });
            }
          } else {
            this.setState({
              showModal: true,
              pdpItem: item,
              pdpCollapse: true,
              title
            });
          }
        }
      } else {
        this.addToCartPayloadHandler(isAdd, item);
      }
    }
  };

  addNewClickHandler = list => {
    console.clear();
    const { pdpItem } = this.state;
    let newData = { ...pdpItem };
    if (newData.variants_quantity === 1) {
      if (newData.addons_quantity !== 0) {
        const payloadForNextApi = {
          entity_id:
            newData?.variant_category?.[0]?.variants?.[0]?.entity_id ??
            newData?.product_entity_id,
          name: newData?.variant_category?.[0]?.name,
          product_id: newData?.id
        };
        this.setState({
          showRepeatCustomization: false,
          pdpItem: newData,
          showModal: false,
          continueClicked: true,
          isNextCloseAll: true,
          payloadForNextApi
        });
      } else {
        newData.entity_id = newData?.variant?.v_entity_id || newData?.entity_id;
        newData.name = '';
        // newData.newId = newData.entity_id;
        // newData.entity_id =
        //   newData.variant_category[0].variants[0].entity_id ||
        //   newData?.product_entity_id;
        this.setState({
          showRepeatCustomization: false,
          continueClicked: true,
          showModal: false,
          itIsFrom: 'addnew',
          isNextCloseAll: true,
          payloadForNextApi: newData,
          pdpItem: newData
        });
      }
    } else {
      // newData.entity_id = newData.variant_category[0].variants[0].entity_id;
      this.setState({
        showRepeatCustomization: false,
        continueClicked: false,
        showModal: true,
        isNextCloseAll: false,
        itIsFrom: 'normal',
        payloadForNextApi: newData,
        pdpItem: newData
      });
    }
  };

  closeRating = () => {
    this.setState({
      showRating: false,
      showFeedback: false,
      fromTickets: false
    });
  };

  repeatCustomizationHandler = () => {
    const { pdpItem } = this.state;
    this.setState({ showRepeatCustomization: false });
    if (pdpItem?.cart_item_id) {
      const { removeCartItemData } = this.props;
      const payload = alterCartItemPayload(pdpItem?.cart_item_id, true);
      removeCartItemData(payload);
      return;
    }
  };

  viewOrderClick = () => {
    const { history, theme } = this.props;
    const { cartData } = this.state;
    const addressInfo = SessionStorage.get(LocalSessionKey.RESTAURANT_DETAIL);
    history.push(_routes.CART);

    trackEvent(view_order, {
      order_mode: SessionStorage.get(LocalSessionKey.ORDER_TYPE),
      city: addressInfo?.city ? addressInfo?.city : '',
      store_id: addressInfo?.outlet_id,
      item_count: cartData?.quantity,
      order_total: cartData?.total_payable_amount,
      crown_points: window.localStorage.getItem('crowns')
        ? window.localStorage.getItem('crowns')
        : 0
    });
  };

  getAddOnConcat = data => {
    const { product_addons } = data;
    let addonConcat = '';
    if (product_addons && product_addons.length)
      product_addons.forEach(addonData => {
        if (addonConcat) addonConcat += '+ ';
        addonConcat += addonData.addon_name;
        return addonData;
      });
    return addonConcat;
  };

  addToCartClickHandler = (isAdd, data) => {
    const { outletid, outletStatus, couponCode } = this.state;
    const outlet = SessionStorage.get(LocalSessionKey.OUTLET_ID);
    if (
      outlet === 32236 ||
      outletid === 32236 ||
      (outletStatus && outletStatus.status)
    ) {
      this.setState({ showModal: false, onRestrict: true });
    }
    this.setState({
      showBackDropLoader: true
    });
    if (data && data.product) {
      const { product } = data;
      product[0].is_from_offer = true;
      if (data.coupon_code !== '') {
        product[0].coupon_code = data.coupon_code;
      }
      if (data.coupon_code === '') {
        product[0].coupon_code = couponCode;
      }
      const { addToCartData, theme } = this.props;
      const itemPayload = addToCartPayload(theme, isAdd, product[0]);
      itemPayload.is_crown_product = data?.is_crown_product || false;
      itemPayload.crowns_to_burn = data?.crowns_to_burn;
      const payload = addToCartUpdatedPayload(itemPayload, []);
      const variant =
        product[0].variant_category.length &&
        product[0].variant_category[0].variants[0];
      const addToCartItems = {
        outlet_id: product[0].outlet_id,
        prid: product[0].id,
        name: product[0].name,
        cart_added_for: product[0].product_type,
        entity_id: product[0].entity_id,
        prqt: product[0].cart_quantity,
        is_customize: String(product[0].is_customise),
        value: variant.price,
        is_repeat: String(product[0].is_repeat),
        is_adding: String(product[0].is_addon_added),
        is_combo: String(product[0].is_combo),
        is_addon: String(product[0].is_addon),
        img_url: product[0].image_urls[0].images[0].image['1x'],
        food_type: product[0].food_type,
        currency: 'INR',
        coupon_code: product[0].coupon_code,
        is_from_offer: String(product[0].is_from_offer),
        is_crown_product: data?.is_crown_product || false
      };
      const addCart = addToCartUpdatedPayload(addToCartItems);
      Analytics.logEventWithVariable(
        Analytics.Order.addToCart,
        JSON.stringify(addCart.data)
      );
      firebase
        .analytics()
        .logEvent('add_to_cart', JSON.stringify(addCart.data));
      const fbscript = document.createElement('script');
      fbscript.src = '//connect.facebook.net/en_US/fbevents.js';
      fbscript.onload = () => {
        fbq('track', 'AddToCart', { items: addCart.data });
      };
      document.head.appendChild(fbscript);
      addToCartData(payload);
    }
  };

  addToCartPayloadHandler = (
    isAdd,
    item,
    is_repeat,
    addons,
    customise,
    custom_quantity,
    addonProdPayload = [],
    extraItems,
    allData
  ) => {
    item.variant_name = this.state?.payloadForNextApi?.name;
    const { addToCartData, theme } = this.props;
    const { variant_category } = item;
    let price = 0;
    let ent_id = '';
    variant_category.map(items => {
      if (items.variants) {
        items.variants.map(value => {
          if (value.custom_price) price = value.custom_price;
          else {
            price = value.price;
          }
          ent_id = value.entity_id;
          return price, ent_id;
        });
      }
    });
    if (!isAdd) {
      alert();
      return;
    } else item.cart_quantity += custom_quantity || 1;
    const itemPayload = addToCartPayload(
      theme,
      isAdd,
      item,
      is_repeat,
      addons,
      customise,
      custom_quantity,
      this.customiseClicked,
      this.state?.payloadForNextApi?.name,
      allData
    );
    if (this.customiseClicked) this.customiseClicked = false;
    const payload = addToCartUpdatedPayload(
      itemPayload,
      addonProdPayload,
      extraItems
    );
    addToCartData(payload);
    // }
    if (isAdd && is_repeat) {
      const variant =
        item.variant_category.length && item.variant_category[0].variants[0];
      Analytics.logEventWithVariable(
        Analytics.Order.addToCart,
        JSON.stringify({
          outlet_id: item.outlet_id,
          prid: item.id,
          name: item.name,
          cart_added_for: variant.service,
          entity_id: item.entity_id,
          prqt: item.cart_quantity,
          price: variant.price,
          is_customize: String(item.is_customise),
          is_repeat: String(is_repeat),
          is_adding: String(item.is_addon_added),
          is_combo: String(item.is_combo),
          is_addon: String(item.is_addon),
          img_url: item?.image_urls?.[0]?.images?.[2]?.image?.['1x'] || '',
          plp_image_url: item.plp_image_url || '',
          pdp_image_url: item.pdp_image_url || '',
          currency: 'INR'
        })
      );
      firebase.analytics().logEvent('add_to_cart', {
        outlet_id: item.outlet_id,
        prid: item.id,
        name: item.name,
        cart_added_for: variant.service,
        entity_id: item.entity_id,
        prqt: item.cart_quantity,
        price: variant.price,
        is_customize: String(item.is_customise),
        is_repeat: String(is_repeat),
        is_adding: String(item.is_addon_added),
        is_combo: String(item.is_combo),
        is_addon: String(item.is_addon),
        img_url: item?.image_urls?.[0]?.images?.[2]?.image['1x'] || '',
        plp_image_url: item.plp_image_url || '',
        pdp_image_url: item.pdp_image_url || '',
        currency: 'INR'
      });
    }

    if (isAdd && !is_repeat) {
      const variant =
        item.variant_category.length && item.variant_category[0].variants[0];
      const addToCartItems = {
        ...item,
        outlet_id: item.outlet_id,
        prid: item.id,
        name: item.name,
        cart_added_for: variant.service,
        entity_id: item.entity_id,
        prqt: item.cart_quantity,
        price: variant.price,
        is_customize: String(item.is_customise),
        is_repeat: String(is_repeat),
        is_adding: String(item.is_addon_added),
        is_combo: String(item.is_combo),
        is_addon: String(item.is_addon),
        img_url: item?.image_urls?.[0]?.images?.[2]?.image?.['1x'] || '',
        currency: 'INR',
        plp_image_url: item.plp_image_url || '',
        pdp_image_url: item.pdp_image_url || '',
        variant_name: this.state?.payloadForNextApi?.name
      };
      const addonProduct = [];
      if (addonProdPayload?.length) {
        addonProdPayload.forEach(value => {
          const items = {
            outlet_id: value.outlet_id,
            prid: value.id,
            name: value.name,
            cart_added_for: value.cart_added_for,
            entity_id: value.entity_id,
            prqt: value.quantity,
            price: value.price,
            is_customize: String(value.is_customise),
            is_repeat: String(value.is_repeat),
            is_adding: String(value.is_adding),
            is_combo: String(value.is_combo),
            is_addon: String(value.is_addon),
            img_url: value.image_url,
            currency: 'INR'
          };
          addonProduct.push(items);
        });
      }
      if (addons && addons.length) {
        addons.forEach(product => {
          const itemData = {
            addon_category_entity_id: product.category_entity_id,
            addon_category_name: product.category_name,
            addon_name: product.name,
            addon_price: product.price,
            addon_entity_id: product.entity_id,
            addon_img_url: product.images,
            addon_prqt: product.quantity,
            addon_prid: product.id,
            addon_currency: 'INR'
          };
          addonProduct.push(itemData);
        });
      }
      const addCart = addToCartUpdatedPayload(
        addToCartItems,
        addonProduct,
        extraItems
      );
      Analytics.logEventWithVariable(
        Analytics.Order.addToCart,
        JSON.stringify(addCart.data)
      );
      firebase
        .analytics()
        .logEvent('add_to_cart', JSON.stringify(addCart.data));
      const fbscript = document.createElement('script');
      fbscript.src = '//connect.facebook.net/en_US/fbevents.js';
      fbscript.onload = () => {
        fbq('track', 'AddToCart', { items: addCart.data });
      };
      document.head.appendChild(fbscript);
    }
    this.setState({
      showModal: false,
      showBackDropLoader: true
    });
  };

  getOfferData = () => {
    const { offerData1 } = this.state;
    setTimeout(() => {
      window.localStorage.setItem('popupShown', true);
      this.setState({ offerApply: false });
    }, 2000);
    if (offerData1 && offerData1.couponCode) {
      return (
        <div className="offerlisting_offer">
          <p className="offerlisting_offer--text">
            {offerData1.couponCode} applied !
          </p>
          <h3 className="offerlisting_offer--heading">{`₹ ${offerData1.freeItemWorth}`}</h3>
          <p className="offerlisting_offer--text">saved with this coupon.</p>
          <p className="offerlisting_offer--notify">
            Enjoy KING DEALS with every order on BK
          </p>
        </div>
      );
    }
  };

  bannerOnClickHandler = data => {
    const {
      product,
      is_from_offer,
      is_from_category,
      is_redemed,
      crowns_to_burn,
      is_static_banner,
      category_id,
      deeplink_type
    } = data;
    if (is_static_banner === 'true') {
      return;
    }
    if (
      is_static_banner === 'false' &&
      (deeplink_type === null || deeplink_type === '') &&
      is_from_offer === false &&
      is_from_category === false &&
      product.length === 0
    ) {
      return;
    }

    if (is_from_offer) {
      const isLoggedIn =
        this.state.isLoggedIn || LocalStorage.get(LocalSessionKey.USER_DATA);

      if (isLoggedIn) {
        if (is_redemed === false && crowns_to_burn && product.length > 0) {
          // Burn the crown modal
          this.setState({
            offersModalContentValue: data,
            showOfferDealModal: true
          });
        } else if (crowns_to_burn) {
          // Fetch coupon data
          this.getCouponsData(data);
          this.setState({
            showBackDropLoader: true,
            stopCarouselSlideShow: true,
            showOfferDealModal: true,
            offersModalContentValue: data
          });
        } else if (!product?.length) {
          // Voucher card for empty product
          this.setState({
            showOfferDealModal: true,
            offersModalContentValue: data,
            stopCarouselSlideShow: true
          });
        } else {
          this.setState({
            showOfferDealModal: true,
            offersModalContentValue: data,
            payloadForNextApi: product[0],
            stopCarouselSlideShow: true
          });
        }
      } else {
        // Show login modal
        this.setState({ showLoginModal: true, stopCarouselSlideShow: true });
      }
      this.offerClickedFrom = 'banner';
    }

    if (is_from_category === true) {
      // Navigate to category
      this.exploreFullMenuclickHandler(category_id);
    }

    if (product && !is_from_offer) {
      const updatedProduct = product.map((item, index) => ({
        ...item,
        type: index === 0 ? 'banner' : item.type || null
      }));
      // Product customization
      this.setState({
        pdpItem: product[0],
        payloadForNextApi: updatedProduct[0],
        continueClicked: true,
        stopCarouselSlideShow: true,
        title: 'homescreenbanner'
      });
    }

    const addressInfo = SessionStorage.get(LocalSessionKey.RESTAURANT_DETAIL);

    trackEvent(homescreen_banner, {
      order_mode: SessionStorage.get(LocalSessionKey.ORDER_TYPE),
      city: addressInfo?.city,
      banner_id: data?.id,
      banner_name: data?.title,
      crown_points: window.localStorage.getItem('crowns')
        ? window.localStorage.getItem('crowns')
        : 0,
      store_name: addressInfo?.outlet_name,
      store_id: addressInfo?.outlet_id
    });
  };

  mobileFooterClickHandler = key => {
    const { history, theme } = this.props;
    const addressInfo = SessionStorage.get(LocalSessionKey.RESTAURANT_DETAIL);
    if (key === 'offers') {
      this.setState({ activeKey: key });
      // alert('Hey! Feature coming soon. stay tuned.');
      history.push(_routes.OFFERS);
      trackEvent(kingdeals_homepage, {
        order_mode: SessionStorage.get(LocalSessionKey.ORDER_TYPE),
        city: addressInfo?.city ? addressInfo?.city : '',
        crown_points: window.localStorage.getItem('crowns')
          ? window.localStorage.getItem('crowns')
          : 0
      });
    }
    if (key === 'stores') {
      history.push(_routes.STORE_LOCATOR);
      this.setState({ activeKey: 'stores' });
      trackEvent(nearbystore_homepage, {
        order_mode: SessionStorage.get(LocalSessionKey.ORDER_TYPE),
        city: addressInfo?.city ? addressInfo?.city : '',
        crown_points: window.localStorage.getItem('crowns')
          ? window.localStorage.getItem('crowns')
          : 0,
        store_name: addressInfo?.outlet_name,
        store_id: SessionStorage.get(LocalSessionKey.OUTLET_ID)
      });
    }
    if (key === 'menu') {
      this.exploreFullMenuclickHandler();
      this.setState({ activeKey: 'menu' });
    }
  };

  seeAllClickHandler = seeAllData => {
    const { type } = seeAllData;
    const { history } = this.props;
    if (type === 'deals_of_the_day') {
      history.push(_routes.OFFERS);
    } else {
      const path = {
        pathname: _routes.SEARCH,
        state: { data: seeAllData }
      };
      history.push(path);
    }
  };

  seeAllPromoClickHandler = (seeAllData, index) => {
    const { apiListData } = this.state;
    const { history } = this.props;
    const flex_details = seeAllData?.flex_details;
    const data = seeAllData?.content?.result;
    // const clickedData = data[index];
    // const { title } = clickedData;
    const title = flex_details?.title;
    // postdata.title = title;
    const { apiListData1 } = this.state;
    const filterCategoryMenuData =
      apiListData1 &&
      apiListData1?.length > 0 &&
      apiListData1?.filter(data => data.content?.flex_details?.type === 'menu');
    const path = {
      pathname: _routes.PRODUCT_LISTING,
      state: {
        categoryId: null,
        data: apiListData1,
        menuData: filterCategoryMenuData?.[0]?.content?.result
        // extra
      }
    };
    history.push(path);
  };

  onGoinOrderClick = data => {
    const { history } = this.props;
    const path = {
      pathname: _routes.TRACK_ORDER,
      state: { data }
    };
    history.push(path);
  };

  toastDestroyHandler = () => {
    this.setState({ toastMessage: '' });
  };

  getBannerData = () => {
    const { apiListData1, stopCarouselSlideShow } = this.state;
    const { bannerOnClickHandler } = this;

    if (apiListData1 && apiListData1.length) {
      const filterData = apiListData1?.filter(
        data => data.content?.flex_details?.type === 'banner'
      );
      SessionStorage.set(LocalSessionKey.BANNER_DATA, filterData);
      if (filterData && filterData[0] && filterData[0].content) {
        return (
          <Carousel
            onClick={bannerOnClickHandler}
            carouselData={filterData[0].content.result}
            stopCarouselSlideShow={stopCarouselSlideShow}
          />
        );
      }
    }
    return null;
  };

  getPathFeedback = () => {};

  getMenuData = () => {
    const { apiListData1 } = this.state;
    const { theme } = this.props;
    if (apiListData1 && apiListData1.length) {
      const filterData = apiListData1?.filter(
        data => data.content?.flex_details?.type === 'menu'
      );
      if (filterData && filterData[0] && filterData[0].content) {
        const FirEl = filterData[0].content;
        const { title } = FirEl.flex_details;
        const { categories } = FirEl.result;

        return (
          <section className="home__section-layout home__ourmenu">
            <HorizontalScroll
              cardType="menu"
              arrowPosition="top"
              data={categories}
              theme={theme}
              sectionTitle={title}
              sectionShowSeeAll
              sectionOnClick={this.exploreFullMenuclickHandler}
              onClick={this.exploreFullMenuclickHandler}
            />
          </section>
        );
      }
    }
    return null;
  };

  getDealOfTheDayData = () => {
    const { apiListData1 } = this.state;
    const { theme } = this.props;
    if (apiListData1 && apiListData1.length) {
      const filterData = apiListData1?.filter(
        data => data.content?.flex_details?.type === 'deals_of_the_day'
      );
      SessionStorage.set(LocalSessionKey.DEALS_OF_THE_DAY, filterData);

      if (filterData && filterData[0] && filterData[0].content) {
        const FirEl = filterData[0].content;
        const { flex_details, result } = FirEl;
        const { title } = flex_details;
        const dealsOfTheDayItems = result.map((item, index) => {
          return (
            <DealsOfTheDay
              item={item}
              key={index.toString()}
              ImgOnclick={this.showOfferDealsModalHandler}
              data={FirEl}
            />
          );
        });
        return dealsOfTheDayItems && dealsOfTheDayItems.length ? (
          <section className="home__section-layout home__section-pad">
            <HorizontalScroll
              sectionTitle={title}
              sectionSeeAllData={FirEl}
              sectionOnClick={this.seeAllClickHandler}
              contentData={dealsOfTheDayItems}
              theme={theme}
            />
          </section>
        ) : (
          ''
        );
      }
    }
  };

  getYourFavouritesData = () => {
    const { apiListData1 } = this.state;
    const { theme } = this.props;
    const { getGeneralCardData } = this;
    if (apiListData1 && apiListData1.length) {
      const filterData = apiListData1?.filter(
        data => data.content?.flex_details?.type === 'favourites'
      );
      if (
        filterData &&
        filterData[0] &&
        filterData[0].content &&
        filterData[0].content.result.length
      ) {
        const { content } = filterData[0];
        const [FirEl] = filterData;
        const { title } = content.flex_details;
        const categoryPayload = content.result;
        return (
          <section className="home__section-layout home__section-pad">
            <HorizontalScroll
              sectionTitle={title}
              sectionShowSeeAll
              sectionSeeAllData={FirEl}
              sectionOnClick={this.exploreFullMenuclickHandler}
              contentData={getGeneralCardData(
                categoryPayload,
                'favourites',
                '',
                categoryPayload
              )}
              theme={theme}
            />
          </section>
        );
      }
    }
    return null;
  };

  getGeneralCardData = (data, titleType, isToShowTwoRows, categoryPayload) => {
    const { theme } = this.props;
    if (isToShowTwoRows) {
      const dom = [];
      dom.push(
        data.slice(0, Math.round(data.length / 2)).map((item, index) => {
          return (
            <GeneralCard
              key={index.toString()}
              item={item}
              theme={theme}
              addOnClick={this.addItemClickHandler}
              categoryPayload={categoryPayload}
              title={titleType}
            />
          );
        })
      );
      dom.push(
        <div className={window?.innerWidth < 1023 ? '' : 'u_2rem_pad_top'}>
          {data
            .slice(Math.ceil(data.length / 2), data.length)
            .map((item, index) => {
              return (
                <GeneralCard
                  key={index.toString()}
                  item={item}
                  theme={theme}
                  addOnClick={this.addItemClickHandler}
                  categoryPayload={categoryPayload}
                  title={titleType}
                />
              );
            })}
        </div>
      );
      return dom;
    }
    return data.map((item, index) => {
      return (
        <GeneralCard
          key={index.toString()}
          item={item}
          theme={theme}
          addOnClick={this.addItemClickHandler}
          categoryPayload={categoryPayload}
          title={titleType}
        />
      );
    });
  };

  getPromoProductsData = () => {
    const { apiListData1 } = this.state;
    const { theme } = this.props;
    const { getGeneralCardData } = this;
    if (apiListData1 && apiListData1.length) {
      const filterData = apiListData1?.filter(
        data => data.content?.flex_details?.type === 'promoproducts'
      );
      if (filterData && filterData[0] && filterData[0].content) {
        const { content } = filterData[0];
        const [FirEl] = filterData;
        const data = content.result;
        return data.map((item, index) => {
          FirEl.index = index;
          const { title, products, card_type } = item;
          const titleType = title.split(' ').join('_');
          const categoryPayload = filterData[0];
          if (products && products.length)
            return (
              <section
                key={index.toString()}
                className="home__section-layout home__section-pad"
              >
                <HorizontalScroll
                  sectionTitle={title}
                  sectionShowSeeAll
                  sectionSeeAllData={FirEl}
                  sectionOnClick={this.seeAllPromoClickHandler}
                  sectionIndex={index}
                  contentData={getGeneralCardData(
                    products,
                    titleType,
                    true,
                    categoryPayload
                  )}
                  theme={theme}
                />
              </section>
            );
          return '';
        });
      }
    }
    return null;
  };

  getTopPicksData = () => {
    const { apiListData } = this.state;
    const { theme } = this.props;
    const { getGeneralCardData } = this;
    if (apiListData && apiListData.length) {
      const filterData = apiListData?.filter(data => data.type === 'top_pics');
      if (
        filterData &&
        filterData[0] &&
        filterData[0].data &&
        filterData[0].data.length
      ) {
        const [FirEl] = filterData;
        const { data } = FirEl;
        const { title, products, card_type } = data;
        const titleType = title.split(' ').join('_');
        const categoryPayload = filterData[0];
        return (
          <section className="home__section-layout">
            <HorizontalScroll
              contentData={getGeneralCardData(
                products,
                titleType,
                '',
                categoryPayload
              )}
              theme={theme}
              sectionTitle={title}
              sectionShowSeeAll
              sectionSeeAllData={FirEl}
              sectionOnClick={this.exploreFullMenuclickHandler}
            />
          </section>
        );
      }
    }
    return null;
  };

  getPromoCardData = () => {
    const { apiListData } = this.state;
    if (apiListData && apiListData.length) {
      const filterData = apiListData.filter(data => data.type === 'promocards');
      if (filterData && filterData[0] && filterData[0].data) {
        const [FirEl] = filterData;
        const { data } = FirEl;
        return data.map(item => {
          const {
            mobile_1x,
            mobile_2x,
            mobile_3x,
            web_1x,
            web_3x,
            web_2x,
            product
          } = item;
          const { innerWidth } = window;
          const imageUrl = {};
          if (innerWidth > 1023) {
            imageUrl['1x'] = web_1x;
            imageUrl['2x'] = web_2x;
            imageUrl['3x'] = web_3x;
          } else {
            imageUrl['1x'] = mobile_1x;
            imageUrl['2x'] = mobile_2x;
            imageUrl['3x'] = mobile_3x;
          }

          return (
            <div className="home__productpromo home__section-layout u_cursor_pointer">
              <picture>
                <source
                  srcSet={`${imageUrl['1x']}, ${imageUrl['2x']} 2x, ${imageUrl['3x']} 3x`}
                  type="image/jpeg/png"
                />
                <img
                  src={`${imageUrl['3x']}`}
                  alt="Product Promo"
                  className={`u_width_height home__productpromo-image ${
                    !(product && product[0]) ? 'u_cursor_not_allowed' : ''
                  }`}
                  onClick={() =>
                    this.addItemClickHandler(true, product && product[0])
                  }
                  role="presentation"
                />
              </picture>
            </div>
          );
        });
      }
    }
    return null;
  };

  getBkWallBannerData = () => {
    const { innerWidth } = window;
    const { bkWallClickHandler } = this;
    return (
      <div
        className="home__bk-wall-banner home__section-layout u_cursor_pointer"
        onClick={bkWallClickHandler}
        role="presentation"
      >
        <img
          src={innerWidth > 1023 ? BKWallBannerImage : BKWallBannerImageMobile}
          alt="bk-wall"
          className="u_width_height u_bor_rad_6px"
        />
      </div>
    );
  };

  comingSoonHandler = () => {
    alert('Hey! Feature coming soon. stay tuned.');
  };

  ModalCloseHandler = () => {
    this.setState({ showRepeatCustomization: false });
  };

  ModalCloseHandler1 = () => {
    this.setState({ showCartCustomization: false });
  };

  offersAddToCartHandler = (
    isAdd,
    item,
    is_repeat,
    addons,
    customise,
    custom_quantity
  ) => {
    const { outletStatus } = this.state;
    const outletid = SessionStorage.get(LocalSessionKey.OUTLET_ID);
    if (outletid === 32236 || (outletStatus && outletStatus.status)) {
      this.setState({ onRestrict: true });
    } else {
      const { addToCartClickHandler } = this;
      const newItem = { item };
      newItem.is_from_offer = true;
      addToCartClickHandler(
        isAdd,
        item,
        is_repeat,
        addons,
        customise,
        custom_quantity
      );
    }
  };

  bkWallClickHandler = () => {
    const { history } = this.props;
    history.push(_routes.BK_WALL);
  };

  onLogoClickHandler = () => {
    const home = document.getElementById('homeTop');
    home.scrollTop = 0;
  };

  setErrorPopup = message => {
    this.setState({ couponError: true, couponErrorPopup: message });
  };

  closeMe = () => {
    const { history } = this.props;
    history.push(_routes.HOME);
  };

  handleChange = (e, id) => {
    if (!e?.label) {
      const { name, value } = e.target;
      if (name === 'phoneNumber') {
        const digitsOnly = value.replace(/\D/g, '');
        this.setState(prev => ({
          ...prev,
          [name]: digitsOnly.slice(0, 10)
        }));
      } else {
        if (name === 'orderId' && value.length > 15) {
          return;
        }
        this.setState(prev => ({
          ...prev,
          [name]: value
        }));
      }
    } else {
      const updateState = {};
      if (id === 'order_type' && e.label === 'Dine-in') {
        updateState.source = { value: 'BK App', label: 'BK App' };
      } else if (id === 'order_type' && e.label === 'Delivery') {
        updateState.source = null;
      }
      this.setState(prevState => ({
        ...prevState,
        [id]: e,
        ...updateState
      }));
    }
  };

  vouchersPageHandler = () => {
    const { history } = this.props;
    history.push(_routes.MY_VOUCHERS);
  };

  handleFileChange = e => {
    const { target } = e;
    const { files } = target;
    if (files && files.length) {
      const selected = files[0];
      if (
        selected.type === 'application/pdf' ||
        selected.type.startsWith('image/')
      ) {
        this.setState({
          formData: files[0]
        });
      } else {
        alert('Only PDFs and images are allowed.');
      }
    }
  };

  validateData = data => {
    const firstName = data.firstName;
    const lastName = data.lastName;
    const phoneNumber = data.phoneNumber;
    const email = data.email;
    const dis = data.dis;
    const source = data.source;
    const orderType = data.order_type;
    const orderId = data.orderId;
    const store = data.store;
    // Validate first name
    if (firstName === '') {
      alert('Please enter your first name.');
      return false;
    }
    // Validate last name
    if (lastName === '') {
      alert('Please enter your last name.');
      return false;
    }
    // Validate Indian phone number
    const phoneNumberRegex = /^[6-9]\d{9}$/; // phone number pattern
    if (!phoneNumberRegex.test(phoneNumber)) {
      alert('Please enter a valid phone number.');
      return false;
    }
    // Validate email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Email pattern
    if (!emailRegex.test(email)) {
      alert('Please enter a valid email address.');
      return false;
    }
    const reg = /^[A-Za-z0-9]{1,15}$/;
    if (orderId === '') {
      alert('Please enter order id');
      return false;
    } else if (!reg.test(orderId)) {
      alert('Please enter a valid order-id');
      return false;
    }
    if (dis === '') {
      alert('Please enter details.');
      return false;
    }
    if (!store) {
      alert('Please Select Store name');
      return false;
    }
    if (!orderType) {
      alert('Please Select order type.');
      return false;
    }
    // orderType;
    if (!source && orderType.label === 'Delivery') {
      alert('Please select source.');
      return false;
    }
    return true;
  };

  handleSubmit = () => {
    const isValid = this.validateData(this.state);
    if (isValid) {
      this.setState({
        loadingProgress: true
      });
      const {
        firstName,
        source,
        lastName,
        email,
        phoneNumber,
        dis,
        order_type: orderType,
        store,
        formData: image,
        orderId
      } = this.state;

      const formData = new FormData();

      formData.append('first_name', firstName);
      formData.append('last_name', lastName);
      formData.append('email', email);
      formData.append('phone_no', phoneNumber);
      formData.append('source', source?.value ?? 'BK app');
      formData.append('details', dis);
      formData.append('order_type', orderType?.value);
      formData.append('outlet_id', store?.value);
      formData.append('outlet_name', store?.label);
      formData.append('order_id', orderId);
      //outlet_id

      // Append the image file if it exists
      if (image) {
        const type = image?.type?.split('/')[0];
        formData.append('type', type || 'image');
        formData.append('image', image);
      }

      fetch(`${process.env.REACT_APP_API_ENDPOINT}${ADD_NEW_FEEDBACK_API}`, {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          this.callCompletedFunction(data);
        })
        .catch(error => {
          console.error(error);
          this.callCompletedFunction(error);
        });
    }
  };

  onDelete = () =>
    this.setState({
      formData: null
    });

  callCompletedFunction = data => {
    if (data?.message === 'success' && data?.error === 0) {
      this.setState({
        show: true,
        firstName: '',
        source: null,
        lastName: '',
        email: '',
        phoneNumber: '',
        orderId: '',
        dis: '',
        order_type: null,
        formData: null,
        store: null
      });
    } else {
      alert(data?.message);
    }
    this.setState({
      loadingProgress: false
    });
  };

  render() {
    const {
      showModal,
      continueClicked,
      payloadForNextApi,
      selectIndex,
      addonDetails,
      isFromSingleVariant,
      pdpCollapse,
      showCartCustomization,
      apiListData1,
      cartData,
      isFromTable,
      pdpItem,
      showRepeatCustomization,
      showBackDropLoader,
      showLoader,
      activeKey,
      showOngoingOrder,
      showOfferDealModal,
      showLoginModal,
      offersModalContentValue,
      userAvailablePoints,
      couponCode,
      ongoingOrderData,
      toastMessage,
      onRestrict,
      title,
      apiListData,
      couponErrorPopup,
      couponError,
      outletStatus,
      showFeedback,
      fromTickets,
      viewedOrder,
      updatedOrder,
      showRating,
      offerApply,
      showPopUp,
      showCluboffer,
      orderStatus,
      loadingProgress
    } = this.state;
    const { theme } = this.props;
    const { innerWidth } = window;
    const {
      termsAndConditionClickHandler,
      closeOfferDealsClickHandler,
      burnValueOnClickHanlder,
      toastDestroyHandler,
      vouchersPageHandler
    } = this;
    const filteredOrderStatus = Array.isArray(orderStatus)
      ? orderStatus.filter(status => status?.status !== 'DELIVERED')
      : [];
    const shouldRenderSwipeCarousel = filteredOrderStatus.length > 0;

    return (
      <div
        className={`home
       ${
         (cartData && cartData.quantity) || showOngoingOrder ? 'home_space' : ''
       }
      ${
        cartData && cartData.quantity && showOngoingOrder
          ? 'home_extra-space'
          : ''
      }`}
        id="homeTop"
      >
        <div className="home__banner">{this.getBannerData()}</div>

        <div className="home__content">
          {apiListData && apiListData.length ? (
            <>
              {this.getMenuData()}
              {this.getPathFeedback()}
              {this.getTopPicksData()}
              {this.getDealOfTheDayData()}
              {this.getYourFavouritesData()}
              {this.getPromoCardData()}
              {this.getPromoProductsData()}

              {apiListData1 &&
              apiListData1.length &&
              apiListData1[1] &&
              apiListData1[1].content ? (
                <div className="home__explore-full-menu">
                  <Button
                    content="Explore full menu"
                    size="is-large"
                    type="block"
                    onClick={() =>
                      this.exploreFullMenuclickHandler(
                        null,
                        null,
                        'Explore full menu'
                      )
                    }
                    theme={theme}
                  />
                </div>
              ) : (
                ''
              )}

              {this.getBkWallBannerData()}
            </>
          ) : (
            ''
          )}
        </div>
        {innerWidth < 1023 ? (
          <div className="home__cart">
            {showOngoingOrder ? (
              <OngoingOrder
                data={ongoingOrderData}
                theme={theme}
                onClick={this.onGoinOrderClick}
              />
            ) : (
              ''
            )}
            {this.props.cartData?.postCart?.content?.total_payable_amount ? (
              <CartSticky
                itemPrice={(cartData && cartData.mprice) || 0}
                itemCount={(cartData && cartData.quantity) || 0}
                offerData={
                  this.props?.cartData?.postCart?.content
                    ?.coupon_recommendation_text
                }
                onclick={this.viewOrderClick}
              />
            ) : (
              ''
            )}

            {shouldRenderSwipeCarousel ? (
              <SwipeCarousel orderStatus={filteredOrderStatus} theme={theme} />
            ) : (
              ''
            )}
            <MobileFooter
              activeKey={activeKey}
              mobileFooterClick={this.mobileFooterClickHandler}
              theme={theme}
            />
          </div>
        ) : (
          <div className="home__cart">
            {showOngoingOrder ? (
              <OngoingOrder
                data={ongoingOrderData}
                theme={theme}
                onClick={this.onGoinOrderClick}
              />
            ) : (
              ''
            )}
          </div>
        )}
        {showModal ? (
          <ProductDetailPage
            onCloseHandler={this.closeClickHandler}
            addToCartPayload={this.addToCartPayloadHandler}
            isCollapse={pdpCollapse}
            theme={theme}
            content={pdpItem}
            isToGetAddonDetail
            title={title}
            payloadForNextApi={payloadForNextApi}
            select={selectIndex}
            selectedFun={this.selectedFun}
            selectedVariant={this.state.selectedVariant}
          />
        ) : (
          ''
        )}
        {continueClicked ? (
          <InfinteScreen
            otherPopUpShow={this.otherPopUpShow}
            otherPopUpHide={this.otherPopUpHide}
            index={this.state.index}
            addToCartPayload={this.addToCartPayloadHandler}
            addonListIds={addonDetails}
            payloadForNextApi={payloadForNextApi}
            content={pdpItem}
            isFromSingleVariant={isFromSingleVariant}
            isCustomise={this.state.itIsFrom}
          />
        ) : null}

        {showCartCustomization ? (
          <Modal onCloseHandler={this.ModalCloseHandler1}>
            <CartCustomize
              cartClick={this.viewOrderClick}
              cancelClick={this.ModalCloseHandler1}
            />
          </Modal>
        ) : (
          ''
        )}

        {showPopUp && (
          <FeedbackLatest
            progressLoader={loadingProgress}
            closeMe={this.closeMe}
            values={this.state}
            dummy={this.state.fileName}
            setValues={this.handleChange}
            handleFileChange={this.handleFileChange}
            handleSubmit={this.handleSubmit}
            onDelete={this.onDelete}
          />
        )}

        {showCluboffer && <OfferOnboarding closeMe={this.closeMe} />}

        {showOfferDealModal ? (
          <OffersModalContent
            termsAndConditionClick={termsAndConditionClickHandler}
            modalContentValue={offersModalContentValue}
            closeOnClick={closeOfferDealsClickHandler}
            burnValueOnClick={burnValueOnClickHanlder}
            onCloseModal={closeOfferDealsClickHandler}
            userAvailablePoints={userAvailablePoints}
            couponCode={couponCode}
            vouchersPageHandler={vouchersPageHandler}
            onClickButton={this.offersAddToCartHandler}
            theme={theme}
          />
        ) : (
          ''
        )}

        {showLoginModal ? (
          <Login
            theme={theme}
            onLoginSuccessHandler={this.onLoginSuccessHandler}
            loggedInToggleHandler={this.loggedInToggleHandler}
          />
        ) : (
          ''
        )}

        {showRepeatCustomization ? (
          <Modal onCloseHandler={this.ModalCloseHandler}>
            <RepeatCustomization
              theme={theme}
              addnewClick={this.addNewClickHandler}
              repeatClick={this.repeatCustomizationHandler}
              name={pdpItem && pdpItem.name}
              extraDetails={pdpItem}
              description={pdpItem && this.getAddOnConcat(pdpItem)}
            />
          </Modal>
        ) : (
          ''
        )}
        {onRestrict ? (
          <LocationRestriction
            title={
              outletStatus && outletStatus.title ? outletStatus.title : 'sorry!'
            }
            description={
              outletStatus && outletStatus.status
                ? outletStatus.status
                : 'None of our restaurants are near you. Please try with some other location'
            }
            okayClick={this.onokayClickHandler}
            theme={theme}
          />
        ) : (
          ''
        )}
        {couponError ? (
          <LocationRestriction
            title="sorry!"
            description={couponErrorPopup}
            okayClick={this.onokayCouponClickHandler}
            theme={theme}
          />
        ) : (
          ''
        )}

        {offerApply && (
          <Cancelpop content children={this.getOfferData()} theme={theme} />
        )}

        {showBackDropLoader ? <LoaderBackDrop theme={theme} /> : ''}
        {showLoader ? <Loader theme={theme} /> : ''}
        {toastMessage ? (
          <OffersToast
            content={toastMessage}
            destroyHanlder={toastDestroyHandler}
          />
        ) : (
          ''
        )}
        {isFromTable && <FeedbackPagee close={this.openPopUp1} />}
        <div className="recent-order_wrapper">
          {viewedOrder?.[0]?.order_detail[0]?.id && showFeedback && (
            <FeedbackPage
              fromTickets={fromTickets}
              theme={theme}
              orderID={123}
              data={viewedOrder[0]?.order_detail[0]}
              wholeOrder={viewedOrder[0]}
              constCall={this.constCall}
              closeRating={this.closeRating}
            />
          )}
          {fromTickets && (
            <FeedbackPage
              fromTickets={fromTickets}
              wholeOrder={updatedOrder[0]}
              FeedbackApiV2={this.getFeedbackApiV2}
              theme={theme}
              orderID={123}
              data={updatedOrder?.[0]?.order_detai[0]}
              constCall={this.constCall}
              closeRating={this.closeRating}
            />
          )}
          {showRating && (
            <RatingPage
              fromTickets={fromTickets}
              FeedbackApiV2={this.getFeedbackApiV2}
              callUpdateFeedbackApi={this.callUpdateFeedbackApi}
              closeRating={this.closeRating}
              theme={theme}
              orderID={1233}
              wholeOrder={!fromTickets ? viewedOrder?.[0] : updatedOrder?.[0]}
              data={
                !fromTickets
                  ? viewedOrder[0]?.order_detail[0]
                  : updatedOrder?.[0]?.order_detai[0]
              }
            />
          )}
        </div>
        {apiListData1 && apiListData1.length > 0 && (
          <Footer onLogoClick={this.onLogoClickHandler} />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    homeData: state.home,
    cartData: state.redisCart,
    offersData: state.offers,
    orderHistoryData: state.orderHistory,
    feedbackStatus: state?.orderHistory?.feedbackStatusList,
    ticketStatus: state?.orderHistory?.ticketStatus
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getHomeApiListData: (payloadData, meta) =>
      dispatch(getHomeApiList(payloadData, meta)),
    addToCartData: payloadData => dispatch(postRedisCart(payloadData)),
    removeCartItemData: payloadData => dispatch(alterRedisCart(payloadData)),
    getCouponsData: payloadData => dispatch(getCoupons(payloadData)),
    getUserAvailablePointsData: payloadData =>
      dispatch(getUserAvailablePoints(payloadData)),
    getAllAddonsData: payloadData => dispatch(getAllAddons(payloadData)),
    getTokenData: payloadData => dispatch(getToken(payloadData)),
    getFeedbackStatus: (payload, meta) =>
      dispatch(getFeedbackStatusList(payload, meta)),
    getTicketStatus: (payload, meta) =>
      dispatch(getTicketStatusList(payload, meta)),
    getIsViewedUpdateApi: (payload, meta) =>
      dispatch(isViewedUpdateApi(payload, meta)),
    postFeedbackApiV2: (payload, meta) =>
      dispatch(feedbackApiV2(payload, meta)),
    updateFeedback: (payload, meta) =>
      dispatch(updateFeedbackApi(payload, meta)),
    getOutletChangeData: (payloadData, meta) =>
      dispatch(getOutletChange1(payloadData, meta))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
